import React from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import HomeIcon from '@mui/icons-material/Home'
import PeopleIcon from '@mui/icons-material/People'
import HandshakeIcon from '@mui/icons-material/Handshake'
import BadgeIcon from '@mui/icons-material/Badge'

const colors = {
  blue: '#0059f6',
  line: '#d9e3f4',
  orange: '#f26b00',
}

const items = [
  { key: 'inicio', label: 'Inicio', icon: HomeIcon },
  { key: 'no_asignadas', label: 'Consultas no asignadas', icon: PeopleIcon },
  { key: 'cerradas', label: 'Consultas cerradas', icon: HandshakeIcon },
  { key: 'clientes', label: 'Clientes', icon: BadgeIcon },
]

export default function AdminInternalNav({
  active = 'inicio',
  onHome,
  onNoAsignadas,
  onCerradas,
  onClientes,
}) {
  const handlers = {
    inicio: onHome,
    no_asignadas: onNoAsignadas,
    cerradas: onCerradas,
    clientes: onClientes,
  }

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.4,
        p: 0.35,
        border: `1px solid ${colors.line}`,
        borderRadius: '10px',
        backgroundColor: 'rgba(255,255,255,0.88)',
        boxShadow: '0 10px 22px rgba(19, 39, 84, 0.08)',
      }}
    >
      {items.map(({ key, label, icon: Icon }) => {
        const selected = active === key
        return (
          <Tooltip key={key} title={label} arrow>
            <IconButton
              aria-label={label}
              onClick={() => handlers[key]?.()}
              sx={{
                width: selected ? 34 : 'auto',
                minWidth: selected ? 34 : 92,
                height: 34,
                px: selected ? 0 : 1.1,
                borderRadius: '8px',
                gap: 0.7,
                color: selected ? '#fff' : colors.orange,
                backgroundColor: selected ? colors.orange : 'transparent',
                border: selected ? `1px solid ${colors.orange}` : '1px solid transparent',
                boxShadow: selected ? 'inset 0 2px 5px rgba(0,0,0,0.18)' : 'none',
                transform: selected ? 'translateY(1px)' : 'translateY(0)',
                transition: 'background-color 160ms ease, color 160ms ease, transform 160ms ease, box-shadow 160ms ease, width 160ms ease',
                '&:hover': {
                  backgroundColor: selected ? '#d95f00' : 'rgba(242,107,0,0.08)',
                  borderColor: selected ? '#d95f00' : 'rgba(242,107,0,0.35)',
                },
              }}
            >
              <Icon sx={{ fontSize: 18 }} />
              {!selected && (
                <Box
                  component="span"
                  sx={{
                    fontSize: 11,
                    fontWeight: 900,
                    lineHeight: 1,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {label}
                </Box>
              )}
            </IconButton>
          </Tooltip>
        )
      })}
    </Box>
  )
}
